import { render, staticRenderFns } from "./marksheetForm.vue?vue&type=template&id=0d35e92c&scoped=true&"
import script from "./marksheetForm.vue?vue&type=script&lang=js&"
export * from "./marksheetForm.vue?vue&type=script&lang=js&"
import style0 from "./marksheetForm.vue?vue&type=style&index=0&id=0d35e92c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d35e92c",
  null
  
)

export default component.exports